/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const trackAuthorBindModelSchema = z.object({
    "id": z.string().uuid().describe("Идентификатор"),
"nickname": z.string().describe("Псевдоним"),
"isCoauthor": z.boolean().describe("Является ли соавтором")
    })